import { render, staticRenderFns } from "./DashboardLinksExport.vue?vue&type=template&id=4fd8a058&"
import script from "./DashboardLinksExport.vue?vue&type=script&lang=js&"
export * from "./DashboardLinksExport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports